"use client";

import { forwardRef } from "react";
import Form from "./form";

const RoomSearchForm = forwardRef((props, ref) => {
  return <Form {...props} ref={ref} />;
});

RoomSearchForm.displayName = "RoomSearchForm";

export default RoomSearchForm;
